import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent, Children, isValidElement, cloneElement } from 'react';
import PT from 'prop-types';
import { C as CardContainer } from './CardContainer-998c7721.js';
import { C as CardBodyStyled } from './Card.styles-397d5ce7.js';
import { C as CardHeader } from './CardHeader-5c534097.js';
import { i as isElementOf$1 } from '../LocalModules/storm-ui-utils/dist/esm/isElementOf-8bc51c5a-e34d7d3f.js';

const isCardHeader = isElementOf$1(CardHeader);
class Card extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onCollapse", event => {
      const {
        collapsable,
        handleCollapseChanged
      } = this.props;
      if (collapsable && handleCollapseChanged) {
        handleCollapseChanged(event);
      }
    });
  }
  render() {
    const {
      children,
      collapsable,
      isCollapsed,
      handleCollapseChanged,
      padding,
      ...rest
    } = this.props;
    let cardHeaderComponent;
    const childrenComponents = [];
    Children.forEach(children, child => {
      if (typeof child === 'string') {
        childrenComponents.push(child);
      }
      if (! /*#__PURE__*/isValidElement(child)) {
        return null;
      }
      if (!cardHeaderComponent && isCardHeader(child)) {
        cardHeaderComponent = child;
      } else {
        childrenComponents.push(child);
      }
      return null;
    });

    // To be collapsible, there must be two or more children, a header and the rest of the content
    if (cardHeaderComponent && collapsable) {
      return /*#__PURE__*/React__default.createElement(CardContainer, _extends({}, rest, {
        isCollapsed: isCollapsed
      }), cardHeaderComponent && /*#__PURE__*/cloneElement(cardHeaderComponent, {
        collapsable,
        isCollapsed,
        onCollapse: this.onCollapse,
        cardPadding: padding
      }), /*#__PURE__*/React__default.createElement(CardBodyStyled, {
        visible: !isCollapsed,
        padding: padding
      }, childrenComponents));
    }
    return /*#__PURE__*/React__default.createElement(CardContainer, rest, cardHeaderComponent && /*#__PURE__*/cloneElement(cardHeaderComponent, {
      cardPadding: padding
    }), /*#__PURE__*/React__default.createElement(CardBodyStyled, {
      padding: padding
    }, childrenComponents));
  }
}
_defineProperty(Card, "propTypes", {
  /**
   * This is the content that will be shown in the Card. If you want to have
   * a Card Header, the first child must be a `<CardHeader />`
   */
  children: PT.node.isRequired,
  /**
   * Specifies whether the card is collapsed. When `true` only the `<CardHeader />`
   * is displayed.
   */
  isCollapsed: PT.bool,
  /**
   * Specifies that the card can be collapsed. The `<CardHeader />` component then
   * renders as a click target which collapses the card when clicked.
   */
  collapsable: PT.bool,
  /**
   * Event handler that is triggered when the user clicks the header of a collapsable card.
   */
  handleCollapseChanged: PT.func,
  /**
   * Sets the padding around the card's content. If the `<Card />` has a `<CardHeader />` then
   * the padding applies to that as well.
   */
  padding: PT.oneOfType([PT.number, PT.oneOf(['none', 'micro', 'mini', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge'])])
});
_defineProperty(Card, "defaultProps", {
  isCollapsed: false,
  collapsable: false,
  handleCollapseChanged: undefined,
  padding: 'xlarge'
});

export { Card as C };
//# sourceMappingURL=Card-b4bdf4bb.js.map
